import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'María',
    location: 'Buenos Aires',
    quote: 'En dos semanas ya tenía mi paquete armado y mis primeros pedidos pagados.',
    age: 32
  }, {
    name: 'Laura',
    location: 'México DF',
    quote: 'Por fin entendí mis costos. Dejé de trabajar gratis sin darme cuenta.',
    age: 28
  }, {
    name: 'Carolina',
    location: 'Bogotá',
    quote: 'Los guiones de WhatsApp me sacaron el bloqueo para cerrar ventas.',
    age: 35
  }, {
    name: 'Ana',
    location: 'Santiago',
    quote: 'El plan de 30 días me dio el orden que necesitaba. Antes solo publicaba fotos sin sentido.',
    age: 42
  }, {
    name: 'Sofía',
    location: 'Lima',
    quote: 'Recuperé la inversión con mi primer pedido. La plantilla de costos vale oro.',
    age: 30
  }];
  return <section className="py-20 md:py-28 bg-beige-sand relative overflow-hidden" data-id="element-266">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-267">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-268">
          <h2 className="text-4xl md:text-5xl font-extrabold text-coffee-dark mb-6 font-heading" data-id="element-269">
            Resultados reales de mujeres como vos
          </h2>
          <div className="flex justify-center gap-1 mb-6" data-id="element-270">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-8 h-8 text-gold-matte fill-current" data-id="element-271" />)}
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-272">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-taupe-light/20 relative" data-id="element-273">
              <div className="text-gold-matte text-4xl font-serif absolute top-4 left-4 opacity-20" data-id="element-274">
                "
              </div>
              <div className="flex gap-1 mb-4" data-id="element-275">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-gold-matte fill-current" data-id="element-276" />)}
              </div>
              <p className="text-lg text-coffee-dark font-medium italic mb-6 relative z-10" data-id="element-277">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center mt-auto border-t border-beige-sand pt-4" data-id="element-278">
                <div className="w-10 h-10 bg-taupe-light rounded-full flex items-center justify-center text-white font-bold mr-3" data-id="element-279">
                  {testimonial.name.charAt(0)}
                </div>
                <div data-id="element-280">
                  <p className="font-bold text-coffee-dark" data-id="element-281">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-sm text-taupe" data-id="element-282">{testimonial.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-center" data-id="element-283">
          <p className="text-taupe italic bg-white/50 inline-block px-6 py-2 rounded-full text-sm" data-id="element-284">
            Estamos sumando historias de alumnas: si comprás y querés contar tu
            experiencia, escribinos.
          </p>
        </motion.div>
      </div>
    </section>;
}